<ul class="hide-bullets">
  <li>
    <a
      class="overlay-link"
      (click)="onLinkClick()"
      href="https://orchestrators.genesys.com/advocacy"
      target="_blank"
      title="Genesys Advocacy Program link"
      >Advocacy Program</a
    >
  </li>
</ul>
